import { useTheme } from 'styled-components'

import OptionFilter from './OptionFilter/OptionFilter'
import { getFilterOptions } from './helpers'
import * as Styles from './styles'

const SentimentFilters = ({ counts, selected, onChange }) => {
  const theme = useTheme()
  return (
    <Styles.Container>
      {getFilterOptions(theme).map(option => (
        <OptionFilter
          key={option.value}
          option={option}
          isActive={option.value === selected}
          total={counts?.[option.value] || 0}
          onChange={onChange}
        />
      ))}
    </Styles.Container>
  )
}

export default SentimentFilters
